(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/tools/section.ts
  var ATTR_SECTION_INITIALIZED = "data-section-initialized";
  var _Section = class _Section {
    constructor(element, selector) {
      // Class itself.
      __publicField(this, "selector");
      __publicField(this, "container");
      __publicField(this, "shopifyContainer");
      __publicField(this, "id");
      __publicField(this, "innerHtmlObserver");
      __publicField(this, "onInnerHtmlMutationObserved", (mutations, observer) => {
        if (!mutations.length) return;
        if (!this.shopifyContainer) return;
        const [mutation] = mutations;
        const removedNodes = [];
        mutation.removedNodes.forEach((n) => removedNodes.push(n));
        const index = removedNodes.findIndex((rn) => rn === this.shopifyContainer);
        if (index === -1) return;
        console.log("Section", this.id, "reloaded.");
        this.dispose();
        _Section.recheck(this.selector);
      });
      this.container = element;
      this.selector = selector;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.shopifyContainer = this.container.parentElement;
      if (this.shopifyContainer && this.shopifyContainer.id) {
        try {
          this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
        } catch (e) {
          console.warn(e);
        }
      }
    }
    /**
     * Register a given section handler for a section selector.
     * 
     * @param selector Selector used to query on the section(s).
     * @param t The handling class for that section.
     * @returns The list of currently registered sections.
     */
    static register(selector, t) {
      const sections = [];
      document.querySelectorAll(selector).forEach((element) => {
        if (_Section.isRegistered(element)) return;
        const sect = new t(element, selector);
        sections.push(sect);
        sect.queryChildren(element);
        sect.init();
        sect.attachEvents(element);
      });
      this.registrations[selector] = t;
      return sections;
    }
    static recheck(selector) {
      const t = this.registrations[selector];
      if (!t) return [];
      return _Section.register(selector, t);
    }
    /**
     * Checks if the given section has been registered or not.
     * 
     * @param element Element to check if has been registered.
     * @returns True if registered, otherwise false.
     */
    static isRegistered(element) {
      return element.hasAttribute(ATTR_SECTION_INITIALIZED);
    }
    replaceContainer(newContainer) {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      this.container.innerHTML = newContainer.innerHTML;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.queryChildren(this.container);
      this.init();
      this.attachEvents(this.container);
    }
    init() {
    }
    dispose() {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      if (this.innerHtmlObserver) this.innerHtmlObserver.disconnect();
    }
  };
  __publicField(_Section, "registrations", {});
  var Section = _Section;

  // scripts/objects/AccordionSlide.ts
  var SELECTOR_SUMMARY = "[data-accordion-title]";
  var SELECTOR_CONTENT = "[data-accordion-body]";
  var AccordionSlide = class {
    constructor(el) {
      __publicField(this, "el");
      __publicField(this, "summary");
      __publicField(this, "content");
      __publicField(this, "animation", null);
      __publicField(this, "isClosing", false);
      __publicField(this, "isExpanding", false);
      __publicField(this, "animationSpeed", 400);
      this.el = el;
      this.summary = el.querySelector(SELECTOR_SUMMARY);
      this.content = el.querySelector(SELECTOR_CONTENT);
    }
    /* --------------------------------------------
     * Public API (used by Accordion)
     * -------------------------------------------- */
    isOpen() {
      return this.el.open;
    }
    toggle() {
      this.isOpen() ? this.close() : this.open();
    }
    open() {
      if (this.isExpanding || this.el.open) return;
      const content = this.el.querySelector("[data-accordion-body]");
      this.el.style.overflow = "hidden";
      this.el.style.height = `${this.el.offsetHeight}px`;
      if (content) content.style.opacity = "1";
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
    close() {
      if (this.isClosing || !this.el.open) return;
      const content = this.el.querySelector("[data-accordion-body]");
      if (content) content.style.opacity = "0";
      this.el.style.overflow = "hidden";
      this.shrink();
    }
    /* --------------------------------------------
     * Animation internals
     * -------------------------------------------- */
    shrink() {
      var _a;
      if (!this.summary) return;
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      (_a = this.animation) == null ? void 0 : _a.cancel();
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        {
          duration: this.animationSpeed,
          easing: "ease-out"
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }
    expand() {
      var _a;
      if (!this.summary || !this.content) return;
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      (_a = this.animation) == null ? void 0 : _a.cancel();
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        {
          duration: this.animationSpeed,
          easing: "ease-out"
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = "";
      this.el.style.overflow = "";
    }
  };

  // scripts/objects/Accordion.ts
  var SELECTOR_SLIDE = "[data-accordion-slide]";
  var CLASS_ANIMATING = "is-animating";
  var ANIMATION_DURATION = 300;
  var Accordion = class {
    constructor(container, disableSize) {
      __publicField(this, "container");
      __publicField(this, "accordionSlideElements", []);
      __publicField(this, "accordionSlides", []);
      __publicField(this, "disableSize", null);
      this.container = container;
      this.accordionSlideElements = Array.from(
        container.querySelectorAll(SELECTOR_SLIDE)
      );
      if (disableSize) this.disableSize = disableSize;
      this.attachEvents();
    }
    /* --------------------------------------------
     * Public API
     * -------------------------------------------- */
    openAccordion() {
      if (this.isAnimating()) return;
      this.accordionSlides.forEach((slide) => slide.open());
    }
    closeAccordion() {
      if (this.isAnimating()) return;
      this.accordionSlides.forEach((slide) => slide.close());
    }
    /* --------------------------------------------
     * Internal helpers
     * -------------------------------------------- */
    isAnimating() {
      return this.container.classList.contains(CLASS_ANIMATING);
    }
    startAnimating() {
      this.container.classList.add(CLASS_ANIMATING);
    }
    stopAnimating() {
      this.container.classList.remove(CLASS_ANIMATING);
    }
    closeOtherSlides(activeSlide) {
      this.accordionSlides.forEach((slide) => {
        if (slide !== activeSlide && slide.isOpen()) {
          slide.close();
        }
      });
    }
    onSlideClick(e, index) {
      e.preventDefault();
      if (this.isAnimating()) return;
      const slide = this.accordionSlides[index];
      if (!slide) return;
      this.startAnimating();
      this.closeOtherSlides(slide);
      slide.toggle();
      window.setTimeout(() => {
        this.stopAnimating();
      }, ANIMATION_DURATION);
    }
    /* --------------------------------------------
     * Events
     * -------------------------------------------- */
    attachEvents() {
      this.accordionSlideElements.forEach((slideElement, i) => {
        const slide = new AccordionSlide(slideElement);
        this.accordionSlides.push(slide);
        const summary = slideElement.querySelector(SELECTOR_SUMMARY);
        if (!summary) return;
        summary.addEventListener("click", (e) => this.onSlideClick(e, i));
      });
    }
    detachEvents() {
      this.accordionSlideElements.forEach((slideElement, i) => {
        const summary = slideElement.querySelector(SELECTOR_SUMMARY);
        if (!summary) return;
        summary.removeEventListener("click", (e) => this.onSlideClick(e, i));
      });
    }
  };

  // scripts/sections/accordion.ts
  var SELECTOR_ACCORDIONS = "[data-accordion-template]";
  var SELECTOR_ACCORDION = "[data-accordion]";
  var AccordionSection = class extends Section {
    constructor() {
      super(...arguments);
      __publicField(this, "accordionElement", null);
      __publicField(this, "accordion", null);
    }
    queryChildren(container) {
      this.accordionElement = container.querySelector(SELECTOR_ACCORDION);
    }
    attachEvents(container) {
      if (this.accordionElement) this.accordion = new Accordion(this.accordionElement);
    }
    detatchEvents() {
      if (this.accordion) this.accordion.detachEvents();
    }
  };
  Section.register(SELECTOR_ACCORDIONS, AccordionSection);
})();
